<div class="mt-6" style="height:420px;max-height:65vh;">
    <ng-content></ng-content>
</div>